import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { APP } from 'src/app/config/app';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  constructor(
    public router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot) {
    let path = route.routeConfig?.path;
    if (path) {
      path = path.split('/')[0];
      if (path && localStorage.getItem(APP.LOCAL_STORAGE_LAST_ROUTE) !== path) {
        localStorage.setItem(APP.LOCAL_STORAGE_LAST_ROUTE, path);
      }
    }
  
    return true;
  }
}
